"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setElencoBonificiRipetitiviSetDataDa = exports.setElencoBonificiRipetitiviSetStati = exports.setElencoBonificiRipetitiviSetBeneficiario = exports.setElencoBonificiRipetitiviSetRapportoSelezionato = exports.setElencoBonificiRipetitiviSetPagamentoRipetitivoSelezionato = exports.getDettaglioBonificoRipetitivo = exports.getElencoBonificiRipetitivi = exports.setBonificoRipetitivoSetBozzaSalvata = exports.getBonificoRipetitivoForModifica = exports.getBonificoRipetitivoFromBozza = exports.delBozzaBonificoRipetitivo = exports.getBozzaBonificoRipetitivo = exports.getBozzeBonificoRipetitivo = exports.autorizzaRevocaBonificoRipetitivo = exports.getInfoRevocaBonificoRipetitivo = exports.setBonificoRipetitivoRevocaSetStep = exports.setProvenienzaRevocaBonificoRipetitivo = exports.setRiepilogoRevocaBonificoRipetitivo = exports.resetBonificoRipetitivo = exports.setFormSubmittedBonificoRipetitivo = exports.setBonificoRipetitivoSetRapportoSelezionato = exports.setBonificoRipetitivoIBANInt = exports.setBonificoRipetitivoIntestatario = exports.setBonificoRipetitivoSetStep = exports.setBonificoRipetitivoSetRataImporto = exports.setBonificoRipetitivoSetRataGiorno = exports.setBonificoRipetitivoSetRataSelected = exports.setBonificoRipetitivoSetDataProssimoPagamento = exports.setBonificoRipetitivoSetFineMese = exports.setBonificoRipetitivoSetGiorno = exports.setBonificoRipetitivoSetNumeroRate = exports.setBonificoRipetitivoSetDataScadenza = exports.setBonificoRipetitivoSetTipoDisposizione = exports.setBonificoRipetitivoSetPeriodo = exports.setBonificoRipetitivoSetTipoDataPagamento = exports.setBonificoRipetitivoSetTipoImporto = exports.setBonificoRipetitivoSetDescrizione = exports.setBonificoRipetitivoSetDataEsec = exports.setBonificoRipetitivoSetImport = exports.setBonificoRipetitivoSetAddWhiteList = exports.setBonificoRipetitivoSetAddRubrica = exports.setBonificoRipetitivoSetIdContattoBeneficiario = exports.setBonificoRipetitivoSetIBAN = exports.setBonificoRipetitivoSetBeneficiario = exports.autorizzaBonificoRipetitivo = exports.getInfoDispositivaBonificoRipetitivo = exports.controlloBonificoRipetitivo = exports.getParametriBonificoRipetitivoForModifica = exports.getParametriElencoBonificiRipetitivi = exports.getParametriBonificoRipetitivo = void 0;
exports.autorizzaModificaBonificoRipetitivo = exports.getInfoDispositivaModificaBonificoRipetitivo = exports.controlloModificaBonificoRipetitivo = exports.esportaElencoRipetitiviEXCEL = exports.esportaElencoRipetitiviPDF = exports.autorizzaRiattivaBonificoRipetitivo = exports.getInfoRiattivaBonificoRipetitivo = exports.setBonificoRipetitivoRiattivaSetStep = exports.setBonificoRipetitivoRiattivaSetDataRiattivazione = exports.setProvenienzaRiattivaBonificoRipetitivo = exports.setRiepilogoRiattivaBonificoRipetitivo = exports.autorizzaSospendiBonificoRipetitivo = exports.getInfoSospendiBonificoRipetitivo = exports.setBonificoRipetitivoSospendiSetStep = exports.setBonificoRipetitivoSospendiSetDataFineSospensione = exports.setBonificoRipetitivoSospendiSetDataInizioSospensione = exports.setProvenienzaSospendiBonificoRipetitivo = exports.setRiepilogoSospendiBonificoRipetitivo = exports.shouldUpdateBozzaBonificoRipetitivo = exports.setElencoBonificiRipetitiviFormDirty = exports.setElencoBonificiRipetitiviOffset = exports.setElencoBonificiRipetitiviResetDettaglioBonificoRipetitivo = exports.resetFormElencoBonificiRipetitivi = exports.setAccordionFiltriOpenedElencoBonificiRipetitivi = exports.setFormSubmittedElencoBonificiRipetitivi = exports.setElencoBonificiRipetitiviSetImporto = exports.setElencoBonificiRipetitiviSetCausale = exports.setElencoBonificiRipetitiviSetDataA = void 0;
const api_rest_1 = require("@sparkasse/api-rest");
const __1 = require("..");
const general_actions_1 = require("../general/general.actions");
const general_configuration_1 = require("../general/general.configuration");
const general_types_1 = require("../general/general.types");
const helpers_1 = require("../helpers");
const bonificoripetitivo_selectors_1 = require("./bonificoripetitivo.selectors");
const moment = require("moment");
/* get parametri - START */
function getParametriBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_PARAMETRI_START
    };
}
function getParametriBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_PARAMETRI_SUCCESS,
        payload
    };
}
function getParametriPerRipetiBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_PARAMETRI_PER_RIPETI_SUCCESS,
        payload
    };
}
function getParametriPerModificaBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_PARAMETRI_PER_MODIFICA_SUCCESS,
        payload
    };
}
function generalError(value, showGenericModalError) {
    return async (dispatch) => {
        dispatch((0, general_actions_1.setError)(value, showGenericModalError));
    };
}
const getParametriBonificoRipetitivo = (ripeti) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getParametriBonificoRipetitivoStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .parametriBonificoRipetitivo().then((response) => {
                var _a;
                dispatch(ripeti ? getParametriPerRipetiBonificoRipetitivoSuccess(response) : getParametriBonificoRipetitivoSuccess(response));
                ((_a = response.rapporti) === null || _a === void 0 ? void 0 : _a.length) === 0 && dispatch((0, general_actions_1.setNoRapporti)({ type: general_types_1.TypeNoRapporti.ELENCO_PAG_RIPETIVI }));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getParametriBonificoRipetitivo = getParametriBonificoRipetitivo;
function getParametriElencoBonificiRipetitiviStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_PARAMETRI_ELENCO_START,
    };
}
function getParametriElencoBonificiRipetitiviSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_PARAMETRI_ELENCO_SUCCESS,
        payload
    };
}
const getParametriElencoBonificiRipetitivi = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getParametriElencoBonificiRipetitiviStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .parametriBonificoRipetitivo().then((response) => {
                var _a;
                dispatch(getParametriElencoBonificiRipetitiviSuccess(response));
                ((_a = response.rapporti) === null || _a === void 0 ? void 0 : _a.length) === 0 && dispatch((0, general_actions_1.setNoRapporti)({ type: general_types_1.TypeNoRapporti.ELENCO_PAG_RIPETIVI }));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getParametriElencoBonificiRipetitivi = getParametriElencoBonificiRipetitivi;
const getParametriBonificoRipetitivoForModifica = () => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getParametriBonificoRipetitivoStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).parametriBonificoRipetitivo().then((response) => {
                dispatch(getParametriPerModificaBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getParametriBonificoRipetitivoForModifica = getParametriBonificoRipetitivoForModifica;
/* get parametri - FINE */
/* controllo bonifico - START */
function controlloBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_CONTROLLO_START
    };
}
function controlloBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_CONTROLLO_SUCCESS,
        payload
    };
}
const controlloBonificoRipetitivo = () => async (dispatch, getState, extraArguments) => {
    const bonificoRipetitivo = getState().bonificoRipetitivo;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(controlloBonificoRipetitivoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/controllo_bonifico_ripetitivo_variabile.json')).then((r) => {
            dispatch(controlloBonificoRipetitivoSuccess((0, api_rest_1.RipetitivoDtoFromJSON)(r)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const controlloBonificoRipetitivoRequest = {
            ripetitivoDto: (0, bonificoripetitivo_selectors_1.buildBonificoRipetitivo)(bonificoRipetitivo)
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .controlloBonificoRipetitivo(controlloBonificoRipetitivoRequest).then((response) => {
                dispatch(controlloBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.controlloBonificoRipetitivo = controlloBonificoRipetitivo;
/* controllo bonifico - FINE */
/* get info dispositiva bonifico - START */
function getInfoDispositivaBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_INFO_DISPOSITIVA_START
    };
}
function getInfoDispositivaBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_INFO_DISPOSITIVA_SUCCESS,
        payload
    };
}
const getInfoDispositivaBonificoRipetitivo = (idDispositiva, eseguiInit, chiamataUscente, offline) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getInfoDispositivaBonificoRipetitivoStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const getInfoDispositivaBonificoRipetitivoRequest = {
            idDispositiva,
            chiamataUscente,
            eseguiInit,
            offline: !!offline
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .informazioniAutenticazioneBonificoRipetitivo(getInfoDispositivaBonificoRipetitivoRequest).then((response) => {
                dispatch(getInfoDispositivaBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getInfoDispositivaBonificoRipetitivo = getInfoDispositivaBonificoRipetitivo;
/* get info dispositiva bonifico - FINE */
/* autorizza bonifico - START */
function autorizzaBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_AUTORIZZA_START
    };
}
function autorizzaBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_AUTORIZZA_SUCCESS,
        payload
    };
}
const autorizzaBonificoRipetitivo = (idDispositiva, credenziale, bonifico) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(autorizzaBonificoRipetitivoStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const getInfoDispositivaBonificoRipetitivoRequest = {
            idDispositiva,
            credenzialeDispositivaDto: credenziale
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .autorizzaBonificoRipetitivo(getInfoDispositivaBonificoRipetitivoRequest).then((response) => {
                dispatch(autorizzaBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error), false));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.autorizzaBonificoRipetitivo = autorizzaBonificoRipetitivo;
/* autorizza dispositiva bonifico - FINE */
function setBonificoRipetitivoSetBeneficiario(txt) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_BENEFICIARIO,
        payload: txt
    };
}
exports.setBonificoRipetitivoSetBeneficiario = setBonificoRipetitivoSetBeneficiario;
function setBonificoRipetitivoSetIBAN(txt) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_IBAN,
        payload: txt
    };
}
exports.setBonificoRipetitivoSetIBAN = setBonificoRipetitivoSetIBAN;
function setBonificoRipetitivoSetIdContattoBeneficiario(id) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_ID_CONTATTO_BENEFICIARIO,
        payload: id
    };
}
exports.setBonificoRipetitivoSetIdContattoBeneficiario = setBonificoRipetitivoSetIdContattoBeneficiario;
function setBonificoRipetitivoSetAddRubrica(b) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_ADD_RUBRICA,
        payload: b
    };
}
exports.setBonificoRipetitivoSetAddRubrica = setBonificoRipetitivoSetAddRubrica;
function setBonificoRipetitivoSetAddWhiteList(b) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_ADD_WHITELIST,
        payload: b
    };
}
exports.setBonificoRipetitivoSetAddWhiteList = setBonificoRipetitivoSetAddWhiteList;
function setBonificoRipetitivoSetImport(i) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_IMPORTO,
        payload: i
    };
}
exports.setBonificoRipetitivoSetImport = setBonificoRipetitivoSetImport;
function setBonificoRipetitivoSetDataEsec(txt) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_DATA_ESEC,
        payload: txt
    };
}
exports.setBonificoRipetitivoSetDataEsec = setBonificoRipetitivoSetDataEsec;
function setBonificoRipetitivoSetDescrizione(txt) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_DESCRIZIONE,
        payload: txt
    };
}
exports.setBonificoRipetitivoSetDescrizione = setBonificoRipetitivoSetDescrizione;
function setBonificoRipetitivoSetTipoImporto(txt) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_TIPO_IMPORTO,
        payload: txt
    };
}
exports.setBonificoRipetitivoSetTipoImporto = setBonificoRipetitivoSetTipoImporto;
function setBonificoRipetitivoSetTipoDataPagamento(txt) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_TIPO_DATA_PAGAMENTO,
        payload: txt
    };
}
exports.setBonificoRipetitivoSetTipoDataPagamento = setBonificoRipetitivoSetTipoDataPagamento;
function setBonificoRipetitivoSetPeriodo(txt, dateStart) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_PERIODO,
        payload: txt,
        dateStart: dateStart
    };
}
exports.setBonificoRipetitivoSetPeriodo = setBonificoRipetitivoSetPeriodo;
function setBonificoRipetitivoSetTipoDisposizione(txt) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_TIPO_DISPOSIZIONE,
        payload: txt
    };
}
exports.setBonificoRipetitivoSetTipoDisposizione = setBonificoRipetitivoSetTipoDisposizione;
function setBonificoRipetitivoSetDataScadenza(txt) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_DATA_SCADENZA,
        payload: txt
    };
}
exports.setBonificoRipetitivoSetDataScadenza = setBonificoRipetitivoSetDataScadenza;
function setBonificoRipetitivoSetNumeroRate(value) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_NUMERO_RATE,
        payload: value
    };
}
exports.setBonificoRipetitivoSetNumeroRate = setBonificoRipetitivoSetNumeroRate;
function setBonificoRipetitivoSetGiorno(value) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GIORNO,
        payload: value
    };
}
exports.setBonificoRipetitivoSetGiorno = setBonificoRipetitivoSetGiorno;
function setBonificoRipetitivoSetFineMese(value) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_FINE_MESE,
        payload: value
    };
}
exports.setBonificoRipetitivoSetFineMese = setBonificoRipetitivoSetFineMese;
function setBonificoRipetitivoSetDataProssimoPagamento(txt) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_DATA_PROSSIMO_PAGAMENTO,
        payload: txt
    };
}
exports.setBonificoRipetitivoSetDataProssimoPagamento = setBonificoRipetitivoSetDataProssimoPagamento;
function setBonificoRipetitivoSetRataSelected(position, value) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_RATA_SELECTED,
        position: position,
        payload: value
    };
}
exports.setBonificoRipetitivoSetRataSelected = setBonificoRipetitivoSetRataSelected;
function setBonificoRipetitivoSetRataGiorno(position, value) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_RATA_GIORNO,
        position: position,
        payload: value
    };
}
exports.setBonificoRipetitivoSetRataGiorno = setBonificoRipetitivoSetRataGiorno;
function setBonificoRipetitivoSetRataImporto(position, value) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_RATA_IMPORTO,
        position: position,
        payload: value
    };
}
exports.setBonificoRipetitivoSetRataImporto = setBonificoRipetitivoSetRataImporto;
function setBonificoRipetitivoSetStepAction(i) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_STEP,
        payload: i
    };
}
const setBonificoRipetitivoSetStep = (i) => async (dispatch, _, extraArguments) => {
    dispatch(setBonificoRipetitivoSetStepAction(i));
    if (extraArguments.platform == 'mobile') {
        dispatch((0, general_actions_1.setBottomTabBarVisible)(i != 2));
    }
};
exports.setBonificoRipetitivoSetStep = setBonificoRipetitivoSetStep;
function setBonificoRipetitivoIntestatario(txt) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_INTESTATARIO,
        payload: txt
    };
}
exports.setBonificoRipetitivoIntestatario = setBonificoRipetitivoIntestatario;
function setBonificoRipetitivoIBANInt(txt) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_IBAN_INT,
        payload: txt
    };
}
exports.setBonificoRipetitivoIBANInt = setBonificoRipetitivoIBANInt;
function setBonificoRipetitivoSetRapportoSelezionato(rapportoSelezionato) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_SET_RAPPORTO_SELEZIONATO,
        payload: rapportoSelezionato
    };
}
exports.setBonificoRipetitivoSetRapportoSelezionato = setBonificoRipetitivoSetRapportoSelezionato;
function setFormSubmittedBonificoRipetitivo(bSelect) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_FORM_SUBMITTED,
        payload: bSelect
    };
}
exports.setFormSubmittedBonificoRipetitivo = setFormSubmittedBonificoRipetitivo;
function resetBonificoRipetitivo() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_RESET
    };
}
exports.resetBonificoRipetitivo = resetBonificoRipetitivo;
function setRiepilogoRevocaBonificoRipetitivo(riepilogo) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_SET_RIEPILOGO_REVOCA,
        payload: riepilogo
    };
}
exports.setRiepilogoRevocaBonificoRipetitivo = setRiepilogoRevocaBonificoRipetitivo;
function setProvenienzaRevocaBonificoRipetitivo(provenienza) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_SET_PROVENIENZA,
        payload: provenienza
    };
}
exports.setProvenienzaRevocaBonificoRipetitivo = setProvenienzaRevocaBonificoRipetitivo;
function setBonificoRipetitivoRevocaSetStepAction(i) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_STEP_REVOCA,
        payload: i
    };
}
const setBonificoRipetitivoRevocaSetStep = (i) => async (dispatch, _, extraArguments) => {
    dispatch(setBonificoRipetitivoRevocaSetStepAction(i));
    if (extraArguments.platform == 'mobile') {
        dispatch((0, general_actions_1.setBottomTabBarVisible)(i != 1));
    }
};
exports.setBonificoRipetitivoRevocaSetStep = setBonificoRipetitivoRevocaSetStep;
/* get info revoca - START */
function getInfoRevocaBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_INFO_REVOCA_START
    };
}
function getInfoRevocaBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_INFO_REVOCA_SUCCESS,
        payload
    };
}
const getInfoRevocaBonificoRipetitivo = (idDispositiva, eseguiInit, chiamataUscente, offline) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getInfoRevocaBonificoRipetitivoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/autenticazione-bonifico.json')).then(parametri => {
            dispatch(getInfoRevocaBonificoRipetitivoSuccess((0, api_rest_1.InformazioniAutenticazioneDispositivaDtoFromJSON)(parametri)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const requestParameters = {
            idDispositiva,
            chiamataUscente,
            eseguiInit,
            offline: !!offline
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .informazioniAutenticazioneRevocaBonificoRipetitivo(requestParameters).then((response) => {
                dispatch(getInfoRevocaBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getInfoRevocaBonificoRipetitivo = getInfoRevocaBonificoRipetitivo;
/* get info revoca - FINE */
/* autorizza revoca - START */
function autorizzaRevocaBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_AUTORIZZA_REVOCA_START
    };
}
function autorizzaRevocaBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_AUTORIZZA_REVOCA_SUCCESS,
        payload
    };
}
const autorizzaRevocaBonificoRipetitivo = (idDispositiva, credenziale, bonificoRipetitivo) => async (dispatch, _, extraArguments) => {
    var _a, _b, _c;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(autorizzaRevocaBonificoRipetitivoStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const requestParameters = {
            ripetitivoRevocaRequestIn: {
                codiceDisposizione: (_a = bonificoRipetitivo.disposizione) === null || _a === void 0 ? void 0 : _a.codiceDisposizione,
                codiceRapporto: (_b = bonificoRipetitivo.ordinante) === null || _b === void 0 ? void 0 : _b.contoAddebito,
                dataRevoca: new Date(),
                statoDisposizione: (_c = bonificoRipetitivo.disposizione) === null || _c === void 0 ? void 0 : _c.statoDisposizione,
                credenziale
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).revocaBonificoRipetitivo(requestParameters).then((response) => {
                dispatch(autorizzaRevocaBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error), false));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.autorizzaRevocaBonificoRipetitivo = autorizzaRevocaBonificoRipetitivo;
/* get autorizza revoca - FINE */
/* get bozze bonifico ripetitivo - START */
const getBozzeBonificoRipetitivo = (BozzeInDto) => async (dispatch, getState, extraArguments) => {
    getBozzeBonifico(BozzeInDto)(dispatch, getState, extraArguments);
};
exports.getBozzeBonificoRipetitivo = getBozzeBonificoRipetitivo;
function getBozzeBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_BOZZE_START
    };
}
function getBozzeBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_BOZZE_SUCCESS,
        payload
    };
}
const getBozzeBonifico = (request) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getBozzeBonificoRipetitivoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/oneclick.json')).then(parametri => {
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else if (request === null || request === void 0 ? void 0 : request.codiceRapporto) {
        const getBozzeBonificoRipetitivoRequest = {
            bozzeInDto: request
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).bozzeBonificoRipetitivo(getBozzeBonificoRipetitivoRequest).then((response) => {
                dispatch(getBozzeBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
/* get bozze bonifico ripetitivo - FINE */
/* get bozza bonifico ripetitivo - START */
const getBozzaBonificoRipetitivo = (id) => async (dispatch, getState, extraArguments) => {
    getBozzaBonifico(id)(dispatch, getState, extraArguments);
};
exports.getBozzaBonificoRipetitivo = getBozzaBonificoRipetitivo;
function getBozzaBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_BOZZA_START
    };
}
function getBozzaBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_BOZZA_SUCCESS,
        payload
    };
}
const getBozzaBonifico = (id) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getBozzaBonificoRipetitivoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/oneclick.json')).then(parametri => {
            // dispatch(getBozzeBonificoRipetitivoSuccess(RipetitivoDtoFromJSON(parametri)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const getBozzaBonificoRipetitivoRequest = {
            id: id
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).bozzaBonificoRipetitivo(getBozzaBonificoRipetitivoRequest).then((response) => {
                dispatch(getBozzaBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
/* get bozza bonifico ripetitivo - FINE */
/* add bozza bonifico sepa - START */
function addBozzaBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_ADD_BOZZA_START
    };
}
function addBozzaBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_ADD_BOZZA_SUCCESS,
        payload
    };
}
const addBozzaBonificoRipetitivo = () => async (dispatch, getState, extraArguments) => {
    const bonificoRipetitivo = getState().bonificoRipetitivo;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(addBozzaBonificoRipetitivoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/oneclick.json')).then(parametri => {
            // dispatch(getBozzeBonificoRipetitivoSuccess(RipetitivoDtoFromJSON(parametri)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const addBozzaBonificoRipetitivoRequest = {
            ripetitivoDto: {
                ...(0, bonificoripetitivo_selectors_1.buildBonificoRipetitivo)(bonificoRipetitivo),
                bozza: {
                    dataUltimaModifica: moment().toDate()
                }
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).salvaBozzaBonificoRipetitivo(addBozzaBonificoRipetitivoRequest).then((response) => {
                dispatch(addBozzaBonificoRipetitivoSuccess(response));
                dispatch((0, general_actions_1.addSnackbar)('bonifico.nuovaBozzaBonificoSalvata'));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
/* add bozza bonifico ripetitivo - FINE */
/* del bozza bonifico sepa - START */
function delBozzaBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_DEL_BOZZA_START
    };
}
function delBozzaBonificoRipetitivoSuccess(id) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_DEL_BOZZA_SUCCESS,
        payload: id
    };
}
const delBozzaBonificoRipetitivo = (id) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(delBozzaBonificoRipetitivoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/oneclick.json')).then(parametri => {
            // dispatch(getBozzeBonificoRipetitivoSuccess(RipetitivoDtoFromJSON(parametri)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const delBozzaBonificoRipetitivoRequest = {
            id
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).eliminaBozzaBonificoRipetitivo(delBozzaBonificoRipetitivoRequest).then(() => {
                dispatch(delBozzaBonificoRipetitivoSuccess(id));
                dispatch((0, general_actions_1.addSnackbar)('bonifico.bozzaEliminataConSuccesso'));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.delBozzaBonificoRipetitivo = delBozzaBonificoRipetitivo;
/* del bozza bonifico sepa - FINE */
/* get bonifico from bozza - START */
function getBonificoRipetitivoFromBozza(payload, noBozza = false) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_BONIFICO_FROM_BOZZA,
        payload,
        noBozza
    };
}
exports.getBonificoRipetitivoFromBozza = getBonificoRipetitivoFromBozza;
/* get bonifico from bozza - FINE */
/* get bonifico for modifica - START */
function getBonificoRipetitivoForModifica(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_BONIFICO_FOR_MODIFICA,
        payload
    };
}
exports.getBonificoRipetitivoForModifica = getBonificoRipetitivoForModifica;
/* get bonifico for modifica - FINE */
/* update bozza bonifico ripetitivo - START */
function updateBozzaBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_UPDATE_BOZZA_START
    };
}
function updateBozzaBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_UPDATE_BOZZA_SUCCESS,
        payload
    };
}
const updateBozzaBonificoRipetitivo = () => async (dispatch, getState, extraArguments) => {
    const bonificoRipetitivo = getState().bonificoRipetitivo;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(updateBozzaBonificoRipetitivoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/bozza_mav_response.json')).then(bozza => {
            //dispatch(updateBozzaBonificoRipetitivoSuccess(BonificoRipetitivoDtoFromJSON(bozza)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const idCurrentBozza = bonificoRipetitivo.currentBozza.id || 0;
        const updateBozzaBonificoRipetitivoRequest = {
            id: idCurrentBozza,
            ripetitivoDto: {
                id: idCurrentBozza,
                ...(0, bonificoripetitivo_selectors_1.buildBonificoRipetitivo)(bonificoRipetitivo),
                bozza: {
                    dataUltimaModifica: moment().toDate()
                }
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).updateBozzaBonificoRipetitivo(updateBozzaBonificoRipetitivoRequest).then((response) => {
                dispatch(updateBozzaBonificoRipetitivoSuccess(response));
                dispatch((0, general_actions_1.addSnackbar)('bonifico.bozzaBonificoAggiornata'));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
/* update bozza bonifico ripetitivo - FINE */
function setBonificoRipetitivoSetBozzaSalvata(value) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_SET_BOZZASALVATA,
        payload: value
    };
}
exports.setBonificoRipetitivoSetBozzaSalvata = setBonificoRipetitivoSetBozzaSalvata;
/* get elenco bonifici ripetitivi - START */
// Restituisce l'archivio pagamenti per il bonifico ripetitivo
function getElencoBonificiRipetitiviStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_GET_ELENCO_START
    };
}
function getElencoBonificiRipetitiviSuccess(payload, offset) {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_GET_ELENCO_SUCCESS,
        payload,
        offset
    };
}
const getElencoBonificiRipetitivi = () => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getElencoBonificiRipetitiviStart());
    const bonificoRipetitivo = getState().bonificoRipetitivo;
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            var _a;
            let requestParameters = {
                codiceRapporto: (_a = bonificoRipetitivo.formElenco.rapportoSelezionato.rapporto) === null || _a === void 0 ? void 0 : _a.id,
                filtroListaBonificiPeriodiciDto: (0, bonificoripetitivo_selectors_1.formElencoBonificiRipetitiviAsFiltro)(bonificoRipetitivo)
            };
            if (extraArguments.platform === 'mobile') {
                requestParameters.filtroListaBonificiPeriodiciDto.offset = (bonificoRipetitivo.formElenco.offset);
            }
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).listaBonificiRipetitivi(requestParameters).then((response) => {
                dispatch(getElencoBonificiRipetitiviSuccess(response, bonificoRipetitivo.formElenco.offset));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getElencoBonificiRipetitivi = getElencoBonificiRipetitivi;
/* get elenco bonifici ripetitivi - FINE */
/* get dettaglio bonifico ripetitivo - START */
// Restituisce il dettaglio di un bonifico ripetitivo da richiamare da archivio pagamenti
function getDettaglioBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_GET_DETTAGLIO_BONIFICO_RIPETITIVO_START
    };
}
function getDettaglioBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_GET_DETTAGLIO_BONIFICO_RIPETITIVO_SUCCESS,
        payload
    };
}
const getDettaglioBonificoRipetitivo = (idDispositiva, codiceRapporto) => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getDettaglioBonificoRipetitivoStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            let requestParameters = {
                idDispositiva,
                codiceRapporto
            };
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).dettaglioBonificoRipetitivo(requestParameters).then((response) => {
                dispatch(getDettaglioBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getDettaglioBonificoRipetitivo = getDettaglioBonificoRipetitivo;
/* get dettaglio bonifico ripetitivo - FINE */
function setElencoBonificiRipetitiviSetPagamentoRipetitivoSelezionato(ripetitivo) {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_SET_PAGAMENTO_RIPETIVIVO_SELEZIONATO,
        payload: ripetitivo
    };
}
exports.setElencoBonificiRipetitiviSetPagamentoRipetitivoSelezionato = setElencoBonificiRipetitiviSetPagamentoRipetitivoSelezionato;
function setElencoBonificiRipetitiviSetRapportoSelezionato(rapportoSelezionato) {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_SET_RAPPORTO_SELEZIONATO,
        payload: rapportoSelezionato
    };
}
exports.setElencoBonificiRipetitiviSetRapportoSelezionato = setElencoBonificiRipetitiviSetRapportoSelezionato;
function setElencoBonificiRipetitiviSetBeneficiario(beneficiario) {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_SET_BENEFICIARIO,
        payload: beneficiario
    };
}
exports.setElencoBonificiRipetitiviSetBeneficiario = setElencoBonificiRipetitiviSetBeneficiario;
function setElencoBonificiRipetitiviSetStati(stati) {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_SET_STATI,
        payload: stati
    };
}
exports.setElencoBonificiRipetitiviSetStati = setElencoBonificiRipetitiviSetStati;
function setElencoBonificiRipetitiviSetDataDa(data) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_DATA_DA,
        payload: data
    };
}
exports.setElencoBonificiRipetitiviSetDataDa = setElencoBonificiRipetitiviSetDataDa;
function setElencoBonificiRipetitiviSetDataA(data) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_DATA_A,
        payload: data
    };
}
exports.setElencoBonificiRipetitiviSetDataA = setElencoBonificiRipetitiviSetDataA;
function setElencoBonificiRipetitiviSetCausale(causale) {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_SET_CAUSALE,
        payload: causale
    };
}
exports.setElencoBonificiRipetitiviSetCausale = setElencoBonificiRipetitiviSetCausale;
function setElencoBonificiRipetitiviSetImporto(importo) {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_SET_IMPORTO,
        payload: importo
    };
}
exports.setElencoBonificiRipetitiviSetImporto = setElencoBonificiRipetitiviSetImporto;
function setFormSubmittedElencoBonificiRipetitivi(submitted) {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_SET_FORM_SUBMITTED,
        payload: submitted
    };
}
exports.setFormSubmittedElencoBonificiRipetitivi = setFormSubmittedElencoBonificiRipetitivi;
function setAccordionFiltriOpenedElencoBonificiRipetitivi(opened) {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_SET_ACCORDION_FILTRI_OPENED,
        payload: opened
    };
}
exports.setAccordionFiltriOpenedElencoBonificiRipetitivi = setAccordionFiltriOpenedElencoBonificiRipetitivi;
function resetFormElencoBonificiRipetitivi() {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_RESET_FORM_ELENCO
    };
}
exports.resetFormElencoBonificiRipetitivi = resetFormElencoBonificiRipetitivi;
function setElencoBonificiRipetitiviResetDettaglioBonificoRipetitivo() {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_RESET_DETTAGLIO_BONIFICO_RIPETITIVO
    };
}
exports.setElencoBonificiRipetitiviResetDettaglioBonificoRipetitivo = setElencoBonificiRipetitiviResetDettaglioBonificoRipetitivo;
function setElencoBonificiRipetitiviOffset(offset) {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_SET_OFFSET,
        payload: offset
    };
}
exports.setElencoBonificiRipetitiviOffset = setElencoBonificiRipetitiviOffset;
function setElencoBonificiRipetitiviFormDirty(dirty) {
    return {
        type: __1.EReduxActionTypes.BONIFICI_RIPETITIVI_SET_FORM_DIRTY,
        payload: dirty
    };
}
exports.setElencoBonificiRipetitiviFormDirty = setElencoBonificiRipetitiviFormDirty;
const shouldUpdateBozzaBonificoRipetitivo = () => async (dispatch, getState, extraArguments) => {
    const state = getState().bonificoRipetitivo;
    if ((0, bonificoripetitivo_selectors_1.checkUpdateBozzaBonificoRipetitivo)(state)) {
        dispatch(updateBozzaBonificoRipetitivo());
    }
    else {
        dispatch(addBozzaBonificoRipetitivo());
    }
};
exports.shouldUpdateBozzaBonificoRipetitivo = shouldUpdateBozzaBonificoRipetitivo;
function setRiepilogoSospendiBonificoRipetitivo(riepilogo) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_SET_RIEPILOGO_SOSPENDI,
        payload: riepilogo
    };
}
exports.setRiepilogoSospendiBonificoRipetitivo = setRiepilogoSospendiBonificoRipetitivo;
function setProvenienzaSospendiBonificoRipetitivo(provenienza) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_SET_PROVENIENZA_SOSPENDI,
        payload: provenienza
    };
}
exports.setProvenienzaSospendiBonificoRipetitivo = setProvenienzaSospendiBonificoRipetitivo;
function setBonificoRipetitivoSospendiSetDataInizioSospensione(data) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_SET_DATA_INIZIO_SOSPENSIONE_SOSPENDI,
        payload: data
    };
}
exports.setBonificoRipetitivoSospendiSetDataInizioSospensione = setBonificoRipetitivoSospendiSetDataInizioSospensione;
function setBonificoRipetitivoSospendiSetDataFineSospensione(data) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_SET_DATA_FINE_SOSPENSIONE_SOSPENDI,
        payload: data
    };
}
exports.setBonificoRipetitivoSospendiSetDataFineSospensione = setBonificoRipetitivoSospendiSetDataFineSospensione;
function setBonificoRipetitivoSospendiSetStepAction(i) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_SET_STEP_SOSPENDI,
        payload: i
    };
}
const setBonificoRipetitivoSospendiSetStep = (i) => async (dispatch, getState, extraArguments) => {
    dispatch(setBonificoRipetitivoSospendiSetStepAction(i));
    if (extraArguments.platform == 'mobile') {
        dispatch((0, general_actions_1.setBottomTabBarVisible)(i != 1));
    }
};
exports.setBonificoRipetitivoSospendiSetStep = setBonificoRipetitivoSospendiSetStep;
/* get info sospendi - START */
function getInfoSospendiBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_INFO_SOSPENDI_START
    };
}
function getInfoSospendiBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_INFO_SOSPENDI_SUCCESS,
        payload
    };
}
const getInfoSospendiBonificoRipetitivo = (idDispositiva, eseguiInit, chiamataUscente, offline) => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getInfoSospendiBonificoRipetitivoStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const requestParameters = {
            idDispositiva,
            chiamataUscente,
            eseguiInit,
            offline: !!offline
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).informazioniAutenticazioneSospendiBonificoRipetitivo(requestParameters).then((response) => {
                dispatch(getInfoSospendiBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getInfoSospendiBonificoRipetitivo = getInfoSospendiBonificoRipetitivo;
/* get info sospendi - FINE */
/* autorizza sospendi - START */
function autorizzaSospendiBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_AUTORIZZA_SOSPENDI_START
    };
}
function autorizzaSospendiBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_AUTORIZZA_SOSPENDI_SUCCESS,
        payload
    };
}
const autorizzaSospendiBonificoRipetitivo = (idDispositiva, credenziale, bonificoRipetitivo) => async (dispatch, getState, extraArguments) => {
    var _a, _b, _c, _d;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(autorizzaSospendiBonificoRipetitivoStart());
    const bonificoRipetitivoSelector = getState().bonificoRipetitivo;
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const requestParameters = {
            ripetitivoSospendiRequestIn: {
                codiceDisposizione: (_a = bonificoRipetitivo.disposizione) === null || _a === void 0 ? void 0 : _a.codiceDisposizione,
                codiceRapporto: (_b = bonificoRipetitivo.ordinante) === null || _b === void 0 ? void 0 : _b.contoAddebito,
                dataInizio: moment(bonificoRipetitivoSelector.formSospendi.dataInizioSospensione.value).toDate(),
                dataFine: ((_c = bonificoRipetitivoSelector.formSospendi.dataFineSospensione) === null || _c === void 0 ? void 0 : _c.value) ? moment(bonificoRipetitivoSelector.formSospendi.dataFineSospensione.value).toDate() : undefined,
                statoDisposizione: (_d = bonificoRipetitivo.disposizione) === null || _d === void 0 ? void 0 : _d.statoDisposizione,
                credenziale
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).sospendiBonificoRipetitivo(requestParameters).then((response) => {
                dispatch(autorizzaSospendiBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error), false));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.autorizzaSospendiBonificoRipetitivo = autorizzaSospendiBonificoRipetitivo;
/* get autorizza sospendi - FINE */
function setRiepilogoRiattivaBonificoRipetitivo(riepilogo) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_SET_RIEPILOGO_RIATTIVA,
        payload: riepilogo
    };
}
exports.setRiepilogoRiattivaBonificoRipetitivo = setRiepilogoRiattivaBonificoRipetitivo;
function setProvenienzaRiattivaBonificoRipetitivo(provenienza) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_SET_PROVENIENZA_RIATTIVA,
        payload: provenienza
    };
}
exports.setProvenienzaRiattivaBonificoRipetitivo = setProvenienzaRiattivaBonificoRipetitivo;
function setBonificoRipetitivoRiattivaSetDataRiattivazione(data) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_SET_DATA_RIATTIVAZIONE_RIATTIVA,
        payload: data
    };
}
exports.setBonificoRipetitivoRiattivaSetDataRiattivazione = setBonificoRipetitivoRiattivaSetDataRiattivazione;
function setBonificoRipetitivoRiattivaSetStepAction(i) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_SET_STEP_RIATTIVA,
        payload: i
    };
}
const setBonificoRipetitivoRiattivaSetStep = (i) => async (dispatch, getState, extraArguments) => {
    dispatch(setBonificoRipetitivoRiattivaSetStepAction(i));
    if (extraArguments.platform == 'mobile') {
        dispatch((0, general_actions_1.setBottomTabBarVisible)(i != 1));
    }
};
exports.setBonificoRipetitivoRiattivaSetStep = setBonificoRipetitivoRiattivaSetStep;
/* get info riattiva - START */
function getInfoRiattivaBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_INFO_RIATTIVA_START
    };
}
function getInfoRiattivaBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_INFO_RIATTIVA_SUCCESS,
        payload
    };
}
const getInfoRiattivaBonificoRipetitivo = (idDispositiva, eseguiInit, chiamataUscente, offline) => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getInfoRiattivaBonificoRipetitivoStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const requestParameters = {
            idDispositiva,
            chiamataUscente,
            eseguiInit,
            offline: !!offline
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).informazioniAutenticazioneRiattivaBonificoRipetitivo(requestParameters).then((response) => {
                dispatch(getInfoRiattivaBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getInfoRiattivaBonificoRipetitivo = getInfoRiattivaBonificoRipetitivo;
/* get info riattiva - FINE */
/* autorizza riattiva - START */
function autorizzaRiattivaBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_AUTORIZZA_RIATTIVA_START
    };
}
function autorizzaRiattivaBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_AUTORIZZA_RIATTIVA_SUCCESS,
        payload
    };
}
const autorizzaRiattivaBonificoRipetitivo = (idDispositiva, credenziale, bonificoRipetitivo) => async (dispatch, getState, extraArguments) => {
    var _a, _b, _c;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(autorizzaRiattivaBonificoRipetitivoStart());
    const bonificoRipetitivoSelector = getState().bonificoRipetitivo;
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const requestParameters = {
            ripetitivoRiattivaRequestIn: {
                codiceDisposizione: (_a = bonificoRipetitivo.disposizione) === null || _a === void 0 ? void 0 : _a.codiceDisposizione,
                codiceRapporto: (_b = bonificoRipetitivo.ordinante) === null || _b === void 0 ? void 0 : _b.contoAddebito,
                dataRiattivazione: moment(bonificoRipetitivoSelector.formRiattiva.dataRiattivazione.value).toDate(),
                statoDisposizione: (_c = bonificoRipetitivo.disposizione) === null || _c === void 0 ? void 0 : _c.statoDisposizione,
                credenziale
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).riattivaBonificoRipetitivo(requestParameters).then((response) => {
                dispatch(autorizzaRiattivaBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error), false));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.autorizzaRiattivaBonificoRipetitivo = autorizzaRiattivaBonificoRipetitivo;
/* get autorizza riattiva - FINE */
function esportaElencoRipetitiviPDFStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_ESPORTA_PDF_ELENCO_RIPETITIVI_START
    };
}
function esportaElencoRipetitiviPDFSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_ESPORTA_PDF_ELENCO_RIPETITIVI_SUCCESS,
        payload
    };
}
const esportaElencoRipetitiviPDF = (share, title, message) => async (dispatch, getState, extraArguments) => {
    var _a;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(esportaElencoRipetitiviPDFStart());
    const bonificoRipetitivo = getState().bonificoRipetitivo;
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const esportaElencoRipetitiviRequest = {
            type: api_rest_1.ExportElencoBonificiRipetitiviTypeEnum.pdf,
            codiceRapporto: ((_a = bonificoRipetitivo.formElenco.rapportoSelezionato.rapporto) === null || _a === void 0 ? void 0 : _a.id) || 0,
            filtroListaBonificiPeriodiciDto: (0, bonificoripetitivo_selectors_1.formElencoBonificiRipetitiviAsFiltro)(bonificoRipetitivo)
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt, 'application/pdf')).exportElencoBonificiRipetitivi(esportaElencoRipetitiviRequest).then((response) => {
                if (extraArguments.platform === 'desktop') {
                    (0, helpers_1.hadlePdfResponse)(response, (url) => dispatch((0, general_actions_1.popUpBlockedPdf)(url)));
                }
                if (extraArguments.platform === 'mobile') {
                    (0, helpers_1.download_sharePDF)(extraArguments, 'ElencoBonificiRipetitivi.pdf', response, share, title, message);
                }
                dispatch(esportaElencoRipetitiviPDFSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.esportaElencoRipetitiviPDF = esportaElencoRipetitiviPDF;
/* export excel elenco - START */
function esportaElencoRipetitiviEXCELStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_ESPORTA_EXCEL_ELENCO_RIPETITIVI_START
    };
}
function esportaElencoRipetitiviEXCELSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_ESPORTA_EXCEL_ELENCO_RIPETITIVI_SUCCESS,
        payload
    };
}
const esportaElencoRipetitiviEXCEL = (share, title, message) => async (dispatch, getState, extraArguments) => {
    var _a;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(esportaElencoRipetitiviEXCELStart());
    const bonificoRipetitivo = getState().bonificoRipetitivo;
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const esportaElencoRipetitiviRequest = {
            type: api_rest_1.ExportElencoBonificiRipetitiviTypeEnum.excel,
            codiceRapporto: ((_a = bonificoRipetitivo.formElenco.rapportoSelezionato.rapporto) === null || _a === void 0 ? void 0 : _a.id) || 0,
            filtroListaBonificiPeriodiciDto: (0, bonificoripetitivo_selectors_1.formElencoBonificiRipetitiviAsFiltro)(bonificoRipetitivo)
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt, 'application/vnd.ms-excel')).exportElencoBonificiRipetitivi(esportaElencoRipetitiviRequest).then((response) => {
                if (extraArguments.platform === 'desktop') {
                    (0, helpers_1.hadleExcelResponse)(response, 'ElencoBonificiRipetitivi.xlsx');
                }
                if (extraArguments.platform === 'mobile') {
                    (0, helpers_1.download_shareXLS)(extraArguments, 'ElencoBonificiRipetitivi.xlsx', response, share);
                }
                dispatch(esportaElencoRipetitiviEXCELSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.esportaElencoRipetitiviEXCEL = esportaElencoRipetitiviEXCEL;
/* export excel elenco - FINE */
/* controllo modifica bonifico ripetitivo - START */
function controlloModificaBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_CONTROLLO_MODIFICA_START
    };
}
function controlloModificaBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_CONTROLLO_MODIFICA_SUCCESS,
        payload
    };
}
const controlloModificaBonificoRipetitivo = () => async (dispatch, getState, extraArguments) => {
    const bonificoRipetitivo = getState().bonificoRipetitivo;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(controlloModificaBonificoRipetitivoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/controllo_bonifico_ripetitivo_variabile.json')).then((r) => {
            dispatch(controlloModificaBonificoRipetitivoSuccess((0, api_rest_1.RipetitivoDtoFromJSON)(r)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const controlloModificaBonificoRipetitivoRequest = {
            modificaRequestDto: (0, bonificoripetitivo_selectors_1.buildModificaBonificoRipetitivo)(bonificoRipetitivo)
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).controlloModificaBonificoRipetitivo(controlloModificaBonificoRipetitivoRequest).then((response) => {
                dispatch(controlloModificaBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.controlloModificaBonificoRipetitivo = controlloModificaBonificoRipetitivo;
/* controllo modifica bonifico ripetitivo - FINE */
/* get info dispositiva modifica bonifico - START */
function getInfoDispositivaModificaBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_INFO_MODIFICA_DISPOSITIVA_START
    };
}
function getInfoDispositivaModificaBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_GET_INFO_MODIFICA_DISPOSITIVA_SUCCESS,
        payload
    };
}
const getInfoDispositivaModificaBonificoRipetitivo = (idDispositiva, eseguiInit, chiamataUscente, offline) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getInfoDispositivaModificaBonificoRipetitivoStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const getInfoDispositivaModificaBonificoRipetitivoRequest = {
            idDispositiva,
            chiamataUscente,
            eseguiInit,
            offline: !!offline
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).informazioniAutenticazioneModifica(getInfoDispositivaModificaBonificoRipetitivoRequest).then((response) => {
                dispatch(getInfoDispositivaModificaBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getInfoDispositivaModificaBonificoRipetitivo = getInfoDispositivaModificaBonificoRipetitivo;
/* get info dispositiva modifica bonifico - FINE */
/* autorizza modifica bonifico - START */
function autorizzaModificaBonificoRipetitivoStart() {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_AUTORIZZA_MODIFICA_START
    };
}
function autorizzaModificaBonificoRipetitivoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BONIFICO_RIPETITIVO_AUTORIZZA_MODIFICA_SUCCESS,
        payload
    };
}
const autorizzaModificaBonificoRipetitivo = (idDispositiva, credenziale, bonifico) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(autorizzaModificaBonificoRipetitivoStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const req = {
            idDispositiva,
            credenzialeDispositivaDto: credenziale
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BonificoRipetitivoControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).autorizzaModificaBonificoRipetitivo(req).then((response) => {
                dispatch(autorizzaModificaBonificoRipetitivoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error), false));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.autorizzaModificaBonificoRipetitivo = autorizzaModificaBonificoRipetitivo;
/* autorizza dispositiva bonifico - FINE */
